import {DELETE_GROUP_CYCLE_START} from "../../types";

export const delete_group_cycle = (payload) => ({
    type: DELETE_GROUP_CYCLE_START,
    payload,
});
